import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import './index.styl'

const ShareholdersMeetingBoardInformation = ({ pageData, activeCat }) => {
  const { t } =  useTranslation()
  const [contentData, setContentData] = useState({})

  useEffect(() => {
    const data = {}
    const keys = []
    pageData.forEach( d => {
      if (!data[d.data_type]){
        data[d.data_type] = []
        keys.push(d.data_type)
      }
      data[d.data_type].unshift(d)
    })
    setContentData(data)
  }, [])

  return (
    <div className="shareholders-meeting-board-information investor__main">
      <h2 className="investor__title">{t(`nav_${activeCat}`)}</h2>
      {
        contentData['shareholders_meeting_notice'] && (
          <table className="investor__table">
            <thead className="investor__table-thead">
              <tr className="investor__table-tr">
                <th className="investor__table-th">{t('shareholdersMeetingBoardInformation.shareholders_meeting_notice')}</th>
              </tr>
            </thead>
            <tbody>
              {
                contentData['shareholders_meeting_notice'].sort((a, b) => (a.sort - b.sort) )
                  .map((d,i) => (
                    <tr 
                      key={d._id}
                      className={classNames('investor__table-tr', {
                        'investor__table-tr--odd': i%2 === 0
                      })}
                    >
                      <td className="investor__table-td">
                        <a href={`https://www.duro.com.tw:8088/api/v1.0/monthly_revenue_pdf/${d.file}`} target="_blank">{d.title}</a>
                      </td>
                    </tr>
                  ))
              }
            </tbody>
          </table>
        )
      }
      {
        contentData['regular_shareholders_handbook'] && (
          <table className="investor__table">
            <thead className="investor__table-thead">
              <tr className="investor__table-tr">
                <th className="investor__table-th">{t('shareholdersMeetingBoardInformation.regular_shareholders_handbook')}</th>
              </tr>
            </thead>
            <tbody>
              {
                contentData['regular_shareholders_handbook'].sort((a, b) => (a.sort - b.sort) )
                  .map((d,i) => (
                    <tr 
                      key={d._id}
                      className={classNames('investor__table-tr', {
                        'investor__table-tr--odd': i%2 === 0
                      })}
                    >
                      <td className="investor__table-td">
                        <a href={`https://www.duro.com.tw:8088/api/v1.0/monthly_revenue_pdf/${d.file}`} target="_blank">{d.title}</a>
                      </td>
                    </tr>
                  ))
              }
            </tbody>
          </table>
        )
      }
      {
        contentData['minutes_of_regular_shareholders'] && (
          <table className="investor__table">
            <thead className="investor__table-thead">
              <tr className="investor__table-tr">
                <th className="investor__table-th">{t('shareholdersMeetingBoardInformation.minutes_of_regular_shareholders')}</th>
              </tr>
            </thead>
            <tbody>
              {
                contentData['minutes_of_regular_shareholders'].sort((a, b) => (a.sort - b.sort) )
                  .map((d,i) => (
                    <tr 
                      key={d._id}
                      className={classNames('investor__table-tr', {
                        'investor__table-tr--odd': i%2 === 0
                      })}
                    >
                      <td className="investor__table-td">
                        <a href={`https://www.duro.com.tw:8088/api/v1.0/monthly_revenue_pdf/${d.file}`} target="_blank">{d.title}</a>
                      </td>
                    </tr>
                  ))
              }
            </tbody>
          </table>
        )
      }
      {
        contentData['annual_report_of_shareholders'] && (
          <table className="investor__table">
            <thead className="investor__table-thead">
              <tr className="investor__table-tr">
                <th className="investor__table-th">{t('shareholdersMeetingBoardInformation.annual_report_of_shareholders')}</th>
              </tr>
            </thead>
            <tbody>
              {
                contentData['annual_report_of_shareholders'].sort((a, b) => (a.sort - b.sort) )
                  .map((d,i) => (
                    <tr 
                      key={d._id}
                      className={classNames('investor__table-tr', {
                        'investor__table-tr--odd': i%2 === 0
                      })}
                    >
                      <td className="investor__table-td">
                        <a href={`https://www.duro.com.tw:8088/api/v1.0/monthly_revenue_pdf/${d.file}`} target="_blank">{d.title}</a>
                      </td>
                    </tr>
                  ))
              }
            </tbody>
          </table>
        )
      }
      {
        contentData['board_information'] && (
          <table className="investor__table">
            <thead className="investor__table-thead">
              <tr className="investor__table-tr">
                <th className="investor__table-th">{t('shareholdersMeetingBoardInformation.board_information')}</th>
              </tr>
            </thead>
            <tbody>
              {
                contentData['board_information'].sort((a, b) => (a.sort - b.sort) )
                  .map((d,i) => (
                    <tr 
                      key={d._id}
                      className={classNames('investor__table-tr', {
                        'investor__table-tr--odd': i%2 === 0
                      })}
                    >
                      <td className="investor__table-td">
                        <a href={`https://www.duro.com.tw:8088/api/v1.0/monthly_revenue_pdf/${d.file}`} target="_blank">{d.title}</a>
                      </td>
                    </tr>
                  ))
              }
            </tbody>
          </table>
        )
      }
    </div>
  )
}

ShareholdersMeetingBoardInformation.propTypes = {}

export default ShareholdersMeetingBoardInformation
